import { createSelector } from 'reselect';
import { subselect } from './root';

const isEnabledSelector = createSelector(
  [(trending) => trending.isEnabled],
  (value) => value || false,
);

export const trendingIsEnabledSelector = subselect(isEnabledSelector);
